export enum OutboundPricingProgram {
  SuspectedFedexEasypostOneRate = "suspected_fedex_easypost_one_rate",
  FedexOneRate = "fedex_one_rate",
}
